__turbopack_context__.v({
  "actions": "landing-header-module__nzT_Da__actions",
  "brand": "landing-header-module__nzT_Da__brand",
  "header": "landing-header-module__nzT_Da__header",
  "iconButton": "landing-header-module__nzT_Da__iconButton",
  "inner": "landing-header-module__nzT_Da__inner",
  "login": "landing-header-module__nzT_Da__login",
  "loginLabel": "landing-header-module__nzT_Da__loginLabel",
  "logo": "landing-header-module__nzT_Da__logo",
  "nav": "landing-header-module__nzT_Da__nav",
  "navLink": "landing-header-module__nzT_Da__navLink",
  "navList": "landing-header-module__nzT_Da__navList",
  "segment": "landing-header-module__nzT_Da__segment",
  "segmentButton": "landing-header-module__nzT_Da__segmentButton",
  "skip": "landing-header-module__nzT_Da__skip",
});
